import type { ReactNode } from "react";

interface AuthShellProps {
  children: ReactNode;
}

// Split-panel grid wrapper.
// Desktop: 1.1fr (brand) + 1fr (form) side-by-side, min 100vh.
// Mobile (< lg): single column — brand panel hides itself via `hidden lg:flex`.
export function AuthShell({ children }: AuthShellProps) {
  return (
    <div
      className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]"
      style={{ minHeight: "max(100vh, 620px)" }}
    >
      {children}
    </div>
  );
}
